import React from 'react'
import { type Parser, domParser } from '.'
import { attributesToProps } from 'html-react-parser'
import { OnScreenAnimation } from './data-on-screen-parser-effects'

export const dataOnScreenParser: Parser = (node, additionalMacros, additionalNodeParsers) => {
  const hasOnScreenAttribute = node.type === 'tag' && node.attribs['data-on-screen']
  if (!hasOnScreenAttribute) {
    return
  }

  const props = attributesToProps(node.attribs)
  const children = node.children.length
    ? domParser(node.children, additionalMacros, additionalNodeParsers)
    : null
  const delay = node.attribs['data-on-screen-delay']
  const onScreenAnimationName = node.attribs['data-on-screen']
  const classNameArray = props.className ? props.className.split(' ') : []

  if (!onScreenAnimationName || !delay) {
    return null
  }

  return (
    <OnScreenAnimation
      elementName={node.name}
      onScreenAnimationName={onScreenAnimationName}
      classNameArray={classNameArray}
      delay={parseInt(delay)}
      props={props}>
      {children}
    </OnScreenAnimation>
  )
}
